import { render, staticRenderFns } from "./Journal.vue?vue&type=template&id=a92214b2&scoped=true"
import script from "./Journal.vue?vue&type=script&lang=js"
export * from "./Journal.vue?vue&type=script&lang=js"
import style0 from "./Journal.vue?vue&type=style&index=0&id=a92214b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92214b2",
  null
  
)

export default component.exports